module.exports = __webpack_public_path__ + "media/images/guide-6-cbbefb6df4b13cbbdd6c4fbabcca70f9.png";